import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ProfileLink from './ProfileLink'

const styles = {
  text: {
    textTransform: 'uppercase',
    color: 'white'
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 20
  },
  img: {
    marginRight: 10,
    maxWidth: 28
  }
}

class NavigationLinks extends React.Component{
  signOutAndNavigate = () => {
    const { signOut, history} = this.props
    signOut();
    history.push('/');
  }

  render() {
    const { auth,  home, classes } =this.props;
    return (
      <div>
        {
          auth.status === 'SIGNED_IN' &&
          <nav className="navbar" role="navigation" aria-label="main navigation">
            <div className="container-fluid">
              <div className="navbar-brand">
                <Link to="/"> <img src="../../../assets/images/header-logo.jpg"/> </Link>
              </div>
              {
                auth.isAdmin === true &&
                getLinksForAdmin(classes)
              }
              {
                (auth.status === 'SIGNED_IN' && auth.isAdmin === false)  &&
                getLinksForCharity(classes, auth)
              }
              <div className="navbar-end">
                  <ProfileLink 
                    auth={auth}
                    signOut={this.signOutAndNavigate} 
                  />
                  
              </div>
            </div>
          </nav>
        }
      </div>
    )
  }
}
export default withStyles(styles)(withRouter(NavigationLinks))

const getLinksForAdmin = (classes): JSX.Element => (
  <div className="navbar-item">
    <div className="navbar-item">
      <Link to="/" className={classes.flex}>
        <img src="/assets/images/donaco-icon.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Home</Typography>
      </Link>
    </div>
    <div className="navbar-item">
      <Link to="/charities" className={classes.flex}>
        <img src="/assets/images/charity.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Charities</Typography>
      </Link>
    </div>
    <div className="navbar-item">
      <Link to="/donations" className={classes.flex}>
        <img src="/assets/images/donations.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Donations</Typography>
      </Link>
    </div>
    <div className="navbar-item">
      {/* <Link to="/placements"> Widget Placements </Link> */}
      <span className={`disabled ${classes.flex}`}>
        <img src="/assets/images/widget.png" className={classes.img} />
        <Typography variant="title" className={`disabled ${classes.text}`}>Widget Placements</Typography>
      </span>
    </div>
    <div className="navbar-item">
      <Link to="/campaigns" className={classes.flex}> 
        <img src="/assets/images/com.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Campaigns </Typography>
      </Link>
    </div>
  </div>
)

const getLinksForCharity = (classes, auth): JSX.Element => (
  <div className="navbar-item">
    <div className="navbar-item">
      <Link to="/" className={classes.flex}> 
        <img src="/assets/images/donaco-icon.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Home</Typography> 
      </Link>
    </div>
    <div className="navbar-item">
      <Link to="/campaigns" className={classes.flex}> 
        <img src="/assets/images/com.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Campaigns</Typography> 
      </Link>
    </div>
    <div className="navbar-item">
      <Link to="/donations" className={classes.flex}> 
        <img src="/assets/images/donations.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Donations </Typography>
      </Link>
    </div>
    <div className="navbar-item">
      <Link to={`/charities/edit/${auth.charityKey}`} className={classes.flex}> 
        <img src="/assets/images/charity.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Charity Profile </Typography>
      </Link>
    </div>
    <div className="navbar-item">
      <Link to="/payments" className={classes.flex}> 
        <img src="/assets/images/payment.png" className={classes.img} />
        <Typography variant="title" className={classes.text}>Payments </Typography>
      </Link>
    </div>
  </div>
)
